<template>
  <div class="max-w-xs mx-auto mt-10 bg-gray-100 p-4 rounded-lg shadow-lg">
    <!-- Display Screen -->
    <!-- <div
      class="mb-4 h-16 bg-gray-200 text-right text-xl font-mono px-4 py-2 rounded-md shadow-inner"
    >
      {{ display }}
    </div> -->

    <!-- Buttons Grid -->
    <div class="grid grid-cols-3 gap-2">
      <button
        v-for="number in numbers"
        :key="number"
        @click="appendNumber(number)"
        class="h-12 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded shadow-md focus:outline-none focus:ring-2 focus:ring-blue-300"
        type="button"
      >
        {{ number }}
      </button>
      <!-- Clear Button -->
      <button
        class="col-span-3 h-12 bg-red-500 hover:bg-red-600 text-white font-semibold rounded shadow-md focus:outline-none focus:ring-2 focus:ring-red-300"
        @click="clearDisplay"
        type="button"
      >
        Clear
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      display: this.modelValue, // Initialize display with modelValue prop
      numbers: ['9', '8', '7', '6', '5', '4', '3', '2', '1', '0', '00', '000'], // Numbers for the keyboard
    };
  },
  watch: {
    // Sync display with modelValue changes from the parent
    modelValue(newValue) {
      console.log('Prop modelValue changed:', newValue);
      this.display = newValue;
    },
  },
  methods: {
    appendNumber(number) {
      // Update display with the appended number
      this.display += number;

      // Emit the update:modelValue event for two-way binding in Vue 3
      this.$emit('update:modelValue', this.display);
    },
    clearDisplay() {
      // Clear display and emit an event
      this.display = '';
      this.$emit('update:modelValue', this.display);
    },
  },
};
</script>

<style>
/* Optionally include additional styles */
</style>
